const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Badge text from a project's tax_year + period_label.
//
// period_label holds a zero-padded month ("07") for monthly/semi-annual work,
// but the whole label ("Jan '26 – Dec '26", "Q3 '26") for other patterns. The
// old badges did parseInt() and coerced NaN to January, so every yearly spawn
// read "Jan <year>" (ENG-120). Only a strict 1-12 number is treated as a month.
export function yearMonthBadge(
  taxYear: number | null | undefined,
  periodLabel: string | null | undefined,
): string | null {
  const year = taxYear ?? null;
  const label = periodLabel?.trim() || null;
  if (label && /^\d{1,2}$/.test(label)) {
    const m = Number(label);
    if (m >= 1 && m <= 12) return year !== null ? `${MONTHS[m - 1]} ${year}` : MONTHS[m - 1];
  }
  if (year !== null) return String(year);
  return label;
}
